
import { Contact, labelForContact } from "@model/contacts/Contact"
import { MechanicSelector } from "@ui/common/MechanicSelector"
import { Grid, GridCont, GridGap } from "@ui/common/grids/Grid"
import { Button, ButtonCont, ButtonTheme, ButtonType } from "@ui/common/buttons/Button"
import {
    Modal,
    ModalBody,
    ModalButtons,
    ModalContent,
    ModalHeader,
    ModalHeaderSubTitle,
    ModalHeaderTitle,
    ModalSize,
} from "@ui/common/Modal"
import {
    DatePicker,
    DatePickerTheme,
    DateTimePicker,
    TextInputDatePicker,
    TextInputDateTimePicker,
} from "@ui/common/form/DatePicker"
import {
    CollapsibleFormField,
    FormField,
    FormFieldDirection,
    FormFieldNote,
    FormFieldNoteType,
} from "@ui/common/form/FormField"
import React, { useEffect } from "react";

export function ReassignWorkOrderModal(
    {
        mechanics, 
        selectedMechanic,        
        dueDate, 
        isModalVisible,
        onClose,
        OnSendWorkOrderConfirmed,
    }: 
    {
        mechanics: Contact[], 
        selectedMechanic: number | null,        
        dueDate: Date | null, 
        isModalVisible: boolean, 
        onClose: () => void,
        OnSendWorkOrderConfirmed: (mechanicId: number | null, dueDate: Date | null) => void,
    }
): JSX.Element {
    const [selectedMechanicModal, setSelectedMechanicModal] = React.useState<number | null>(selectedMechanic);
    const [dueDateModal, setDueDateModal] = React.useState<Date | null>(dueDate);

    useEffect(() => {
        setSelectedMechanicModal(selectedMechanic);
        setDueDateModal(dueDate);
    }, [selectedMechanic, dueDate]);

    return (
        <Modal isVisible={isModalVisible} useContentTag={true} onClose={onClose} size={ModalSize.Normal}>
            <ModalContent>
                <ModalHeader>
                    <ModalHeaderTitle>
                        Reassign Work Order
                    </ModalHeaderTitle> 
                    <ModalHeaderSubTitle>
                        Select a Mechanic and set a due date to assign work order over.
                    </ModalHeaderSubTitle>  
                </ModalHeader>
                <ModalBody>
                    <Grid columns={1}>                
                        <FormField
                            label={"Work Order Due Date"}
                            direction={FormFieldDirection.Column}
                        >
                            <TextInputDateTimePicker
                                value={dueDateModal}
                                onChange={(date) => setDueDateModal(date)}                                
                                disablePast={false}
                            />
                            <FormFieldNote type={FormFieldNoteType.Info}>
                                Select when this work order should be completed.
                            </FormFieldNote>
                        </FormField>
                        <FormField>
                            <MechanicSelector
                                selected={selectedMechanicModal}
                                mechanics={mechanics}
                                OnSelected={setSelectedMechanicModal}
                            />
                        </FormField>
                    </Grid>
                </ModalBody>
                <ModalButtons>
                    <Button
                        label={"Unassign"}
                        type={ButtonType.Text}
                        theme={ButtonTheme.Dark}
                        isEnabled={selectedMechanicModal !== null}
                        onClick={() => { OnSendWorkOrderConfirmed(null,dueDateModal); onClose(); }}
                    />
                    <Button label={"Cancel"} onClick={() => onClose()} />
                    <Button
                        label={"Save"}
                        type={ButtonType.Text}
                        theme={ButtonTheme.Dark}
                        isEnabled={selectedMechanicModal !== null}
                        onClick={() => { OnSendWorkOrderConfirmed(selectedMechanicModal,dueDateModal); onClose(); }}
                    />                    
                </ModalButtons>
            </ModalContent>
        </Modal>        
    )
}